module.exports = __webpack_public_path__ + "img/strategy_bb_grey.38f6447e.svg";